import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Css3 = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Css3' {...props}>
    <path fill='none' stroke='#000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M7,3 L21,3 L18,18 L10,22 L3,18 L4,14 M5,9 L19,9' />
  </StyledIcon>
);
